import { TanStackDevtools } from "@tanstack/react-devtools";
import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";
import { env } from "@/env";

interface MyRouterContext {
	queryClient: QueryClient;
	userId: string | null;
	get_token: () => Promise<string | null>;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => (
		<>
			{/*
			 THESIS: The admin back-office becomes the same calm front-desk software as the
			 customer app — warm-paper canvas, one indigo voice — refusing the grey control-desk it was.
			 OWN-WORLD: Warm-paper (#f4f3ef) canvas under white cards, indigo (#4b3fe4) spent only on
			 action/selection/focus, dedicated sidebar surface (#fbfaf7), Hanken Grotesk UI + JetBrains
			 Mono figures, calm tinted status chips, nearly flat (shadow-xs/sm).
			 STORY: An operator scans tenants, prices plans, and clears tickets fast, in one identity.
			 FIRST VIEWPORT: White header + wordmark, indigo-active sidebar on paper canvas, dense zebra tables.
			 FORM: User-pinned redesign — port of the shipped PilatesTime "Front Desk" world (no roll).
			 FINISH: unreviewed and undocumented is unfinished; this build ends with the finish review, the verdict, and DESIGN.md
			*/}
			<Outlet />
			{env.VITE_APP_ENVIRONMENT === "local" && (
				<>
					<TanStackDevtools
						config={{
							position: "bottom-left",
						}}
						plugins={[
							{
								name: "Tanstack Router",
								render: <TanStackRouterDevtoolsPanel />,
							},
						]}
					/>
					<ReactQueryDevtools buttonPosition="bottom-right" />
				</>
			)}
		</>
	),
});
